import {Component, Inject} from '@angular/core';
import {Location} from '@angular/common';
import {Router, ActivatedRoute} from '@angular/router';

import {Guide} from '../../core/model';
import {GuideService} from '../../services/guide.service';
import {WindowService} from '../../services/window.service';


@Component({
  selector: 'spot-details',
  templateUrl: './spot-details.component.html',
  styleUrls: [
    '../../../assets/css/main.less',
    './spot-details.component.less'
  ]
})
export class SpotDetailsComponent {

  private navigationLink = '#';
  spot: any = {};

  constructor(private route: ActivatedRoute, private router: Router, private guideService: GuideService, @Inject(WindowService) private _window: Window) {
    this.spot.category = {};
  }

  ngOnInit() {
    this.guideService.getActiveGuide().then(guide => {
      this.route.params.subscribe(params => {
        this.showSpotDetails(guide, params['id']);
      });
    });
  }

  back() {
    this.router.navigate(['/']);
  }

  public navigate() {
    this._window.open(this.navigationLink);
  }

  public showOnMap() {
    this.router.navigate(['/map', this.spot._id]);
  }

  public setLinkToGoogleMaps() {
    const latlng = this.spot.geolocation.geometry.coordinates;
    const latlngRevers = latlng[1] + ',' + latlng[0];
    this.navigationLink = 'http://maps.google.de/maps?q=' + latlngRevers + '&t=k&z=19';
  }

  showSpotDetails(guide: Guide, spotId) {
    guide.spots.forEach(spot => {
      if (spot._id == spotId) {
        this.spot = spot;
        this.setLinkToGoogleMaps();
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/components/spot-details/spot-details.component.ts